<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="getList">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="公众号">
              <a-select
                placeholder="请选择渠道"
                v-model="queryParam.appId"
                @change="handleChange"
                id="aa"
              >
                <a-select-option v-for="item in wechatApp" :key="item.appId">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="7" :md="10" :sm="24">
            <a-form-item label="名字">
              <a-input
                placeholder="输入名字模糊查询"
                v-model="queryParam.name"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="11" :md="12" :sm="20">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQueryAfter" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="status" slot-scope="text, record">
          {{ record.status == 1 ? '正常' : '禁用' }}
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="handleDelete(record.id)">
            删除
          </a>
        </span>
      </a-table>
    </div>

    <EventCommandModal ref="modalForm" @ok="getList()"></EventCommandModal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import JInput from '@/components/jeecg/JInput';
import EventCommandModal from './modules/addModel.vue';
import { getAction, postAction } from '@api/manage';

export default {
  name: 'EventCommandIndex',
  components: {
    JInput,
    EventCommandModal
  },
  data() {
    return {
      dataSource: [],
      appId: '',
      selectedRowKeys: [],
      description: 'WECHAT_APP管理页面',
      queryParam: {
        appId: ''
      },
      wechatApp: [],
      // 表头
      columns: [
        {
          title: '指令名字',
          align: 'center',
          dataIndex: 'name'
        },
        {
          title: '事件指令',
          align: 'center',
          dataIndex: 'eventCommand'
        },
        {
          title: '处理类型',
          align: 'center',
          dataIndex: 'handleType'
        },
        {
          title: '处理内容',
          align: 'center',
          dataIndex: 'handleContent'
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_WECHAT + '/eventCommand/list',
        delete: process.env.VUE_APP_CMS_WECHAT + '/eventCommand/remove'
      },
      dictOptions: {},
      loading: false,
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      }
    };
  },
  created() {
    this.getWechatApp();
  },
  methods: {
    handleChange(value) {
      console.warn(value);
      this.queryParam.appId = value;
    },
    searchReset() {
      this.queryParam.name = '';
      this.queryParam.appId = this.appId;
      this.getList();
    },
    getList() {
      let page = {
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      };
      let params = Object.assign(this.queryParam, page);
      this.loading = true;
      getAction(this.url.list, params).then(res => {
        if (res.success) {
          this.dataSource =
            res.result && res.result.records ? res.result.records : [];
          this.loading = false;
          this.ipagination.total = res.result.total;
        }
      });
    },
    getWechatApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: '1,2'
      }).then(res => {
        if (res.success) {
          this.queryParam.appId = res.result[0].appId;
          this.appId = res.result[0].appId;
          this.wechatApp = res.result;
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    searchQueryAfter() {
      if (!this.queryParam.appId) {
        this.$message.warn('请选择公众号');
        return;
      }
      this.getList();
    },
    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.appId = this.queryParam.appId;
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.appId = this.queryParam.appId;
    },

    //删除
    handleDelete(id) {
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function() {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.ipagination.pageNo = 1;
                that.getList();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //清空选中的数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      this.ipagination = pagination;
      this.getList();
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
